import React, { useContext } from 'react';

type PresenterModeContextType = {
	isPresenterModeActive: boolean;
	isBrowserFullscreen: boolean;
	isPresenterModeEnabled: boolean;
	hasEnteredPresentMode: boolean;
	enterPresenterMode: () => void;
	exitPresenterMode: () => void;
	enterBrowserFullscreen: () => void;
	enterSystemFullscreen: () => void;
	presenterModeContextError: Error | null;
	setPresenterModeContextError: React.Dispatch<React.SetStateAction<any>>;
	setIsBrowserFullscreen: React.Dispatch<React.SetStateAction<boolean>>;
	setHasEnteredPresentMode: React.Dispatch<React.SetStateAction<boolean>>;
};
export const PresenterModeContext: React.Context<PresenterModeContextType> =
	React.createContext<PresenterModeContextType>({
		isPresenterModeActive: false,
		isBrowserFullscreen: false,
		hasEnteredPresentMode: false,
		presenterModeContextError: null,
		isPresenterModeEnabled: false,
		enterPresenterMode: () => {
			// Intentional no-op
		},
		exitPresenterMode: () => {
			// Intentional no-op
		},
		setPresenterModeContextError: () => {
			// Intentional no-op
		},
		enterBrowserFullscreen: () => {
			// Intentional no-op
		},
		enterSystemFullscreen: () => {
			// Intentional no-op
		},
		setIsBrowserFullscreen: () => {
			// Intentional no-op
		},
		setHasEnteredPresentMode: () => {
			// Intentional no-op
		},
	});

export const usePresenterModeContext = (): PresenterModeContextType => {
	return useContext(PresenterModeContext);
};
